<ui-button type="outline" [matMenu]="hireButtonMenu"
    >{{ 'applicant-tracker.applicants.hire' | appTranslate }} <mat-icon svgIcon="chevronDown"></mat-icon>
</ui-button>
<mat-menu #hireButtonMenu="matMenu">
    <button mat-menu-item (click)="onSendOffer()">{{ 'applicant-tracker.applicants.sendOffer' | appTranslate }}</button>
    <button mat-menu-item *ngIf="!applicant.archivedAt" (click)="onHire()">
        {{ 'applicant-tracker.applicants.hire' | appTranslate }}
    </button>
</mat-menu>
